<div class="fifty-fifty-view">
  <div class="forgot-password-container flex-column">
    <elab-forgot-password-form></elab-forgot-password-form>
  </div>
</div>

